import { render, staticRenderFns } from "./BottomChannel.vue?vue&type=template&id=34854bd6"
import script from "./BottomChannel.vue?vue&type=script&lang=js"
export * from "./BottomChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports